// Events table renderer. Polls the EventStore and updates the DOM.
// Click on a snapshot thumbnail opens the full image in a <dialog>.

import type { EventStore } from "../storage/indexeddb";

export class EventsTable {
  private tbody: HTMLTableSectionElement;
  private dialog: HTMLDialogElement;
  private dialogImg: HTMLImageElement;

  constructor(private store: EventStore) {
    const table = document.getElementById("events-table") as HTMLTableElement;
    const tbody = table.querySelector("tbody");
    if (!tbody) throw new Error("events-table tbody missing");
    this.tbody = tbody as HTMLTableSectionElement;
    this.dialog = document.getElementById("snap-dialog") as HTMLDialogElement;
    this.dialogImg = document.getElementById("snap-img") as HTMLImageElement;
    document.getElementById("snap-close")?.addEventListener("click", () => this.dialog.close());
  }

  async refresh(): Promise<void> {
    const events = await this.store.listEvents(100);
    if (events.length === 0) {
      this.tbody.innerHTML = `<tr><td colspan="7" class="empty">no events yet</td></tr>`;
      return;
    }
    const rows: string[] = [];
    for (const r of events) {
      const j = r.json as Record<string, unknown>;
      const eid = String(j.event_id);
      const ts = String(j.timestamp).replace("T", " ").replace("Z", "");
      const cls = String(j["class"]);
      const tid = j.track_id === null ? "—" : String(j.track_id);
      const conf = (j.confidence as number).toFixed(2);
      const seen = (j.seen_for_seconds as number).toFixed(1) + "s";
      const hasSnap = typeof j.snapshot_path === "string";
      const snapCell = hasSnap
        ? `<img class="thumb" data-event="${eid}" alt="snapshot" />`
        : "—";
      rows.push(
        `<tr><td>${eid}</td><td>${ts}</td><td>${cls}</td>` +
          `<td>${tid}</td><td>${conf}</td><td>${seen}</td><td>${snapCell}</td></tr>`,
      );
    }
    this.tbody.innerHTML = rows.join("");
    // Lazy-load thumbnails
    for (const img of this.tbody.querySelectorAll<HTMLImageElement>("img.thumb")) {
      const eid = img.dataset["event"]!;
      const blob = await this.store.getSnapshot(eid);
      if (blob) {
        const url = URL.createObjectURL(blob);
        img.src = url;
        img.addEventListener("click", () => {
          this.dialogImg.src = url;
          this.dialog.showModal();
        });
      }
    }
  }
}
